// extracted by mini-css-extract-plugin
module.exports = {"listVideo":"Video_listVideo_3itCu","brandList":"Video_brandList_1Osys","navigation":"Video_navigation_3zbgz","dialogVideo":"Video_dialogVideo_1jGuL"};